export const themeLight = {
  bgSidebar: "#FFFFFF",
  textColor: "#000",
  textLightColor: "#C5C5C5",
  bgContent: "#F6F6F8",
  bgBlue: "#4050D1",
  bgOrange: "#FFC05D",
  bgYellow: "#FFDB4B",
  bgTemp: "#fff",
  bgTempActive: "#000",
  bgTempText: "#000",
  bgTempTextActive: "#fff",
  bgIcon: "#fff",
};

export const themeDark = {
  bgSidebar: "#212121",
  textColor: "#FFFFFF",
  textLightColor: "#BEBEBE",
  bgContent: "#292929",
  bgBlue: "#092C6C",
  bgOrange: "#FFC05D",
  bgYellow: "#F5D47C",
  bgTemp: "#000",
  bgTempActive: "#fff",
  bgTempText: "#fff",
  bgTempTextActive: "#000",
  bgIcon: "#fff",
};
